"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectDevice = void 0;
const base_1 = require("./base");
class IkeObjectDevice extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'Device';
        this.actionName = 'device';
        this.cacheKeys['deviceId'] = true;
    }
}
exports.IkeObjectDevice = IkeObjectDevice;
//# sourceMappingURL=device.objects.js.map